import { createSlice } from '@reduxjs/toolkit'

const chatList = createSlice({
    name: 'chatList',
    initialState: {
        list: [],//Все чаты
        list_object: [],//Чаты по объектам
        list_loaded: [] //Список загруженных проектов
    },
    reducers: {
        loadObject(state, action) {
            const id_object = parseInt(action.payload.id_object);
            /*
            ID	Name
            1	Личный
            2	Беседа
            3	Техническая поддержка
            4	Задача
            5	Задача доски
            */
            state.list_object = [...state.list.filter(a => a.ID_Object !== id_object), ...action.payload.list];
            state.list_loaded = [...state.list_loaded.filter(a => a.id_object !== id_object), { id_object: id_object }];
        },
        set(state, action) {
            const model = action.payload.model;

            state.list = [...state.list.filter(a => a.ID !== model.ID), model];
            //Если задача или задача доски, то обновляем коллекцию list_object
            if (model.ID_Object === 4 || model.ID_Object === 5) {
                state.list_object = [...state.list.filter(a => a.ID !== model.ID), model];
            }
        },
    }
})

export const { loadObject, set } = chatList.actions
export default chatList.reducer